var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"warning"},on:{"click":function($event){return _vm.transfer()}}},[_vm._v("移譲")])}
var staticRenderFns = []

export { render, staticRenderFns }